// # interfaces
import { iContentEditorProps } from './interfaces';

export const defaultProps: Partial<iContentEditorProps> = {
    config: {
        height: 400,
    },
    plugins: [
        'code',
        'hr',
        'image',
        'link',
        'lists',
        'table',
    ],
    toolbarsGrouped: [
        [
            [
                'undo',
                'redo',
            ],
            [
                'alignjustify',
                'alignleft',
                'alignnone',
                'alignright',
            ],
            [
                'bold',
                'italic',
                'underline',
                'strikethrough',
            ],
            [
                'numlist',
                'bullist',
                'indent',
                'outdent',
            ],
        ],
        [
            [
                'image',
                'link',
                'unlink',
            ],
            [
                'table',
                'hr',
                'blockquote',
            ],
        ],
    ],
};

export default defaultProps;
